import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import FormWrapper from '../../share/FormWrapper/FormWrapper';
import GroupsList from './GroupsList';
import SemestersList from './SemestersList';
import TeachersList from './TeachersList';
import DepartmentsList from './DepartmentsList';
import { userRoles } from '../../constants/userRoles';
import { getAllPublicGroupsStart } from '../../actions/groups';
import { useDefaultSemester } from '../../hooks/useSchedule';

const SchedulePageForm = ({ onSubmit }) => {
    const { t } = useTranslation('common');
    const dispatch = useDispatch();

    const userRole = useSelector((state) => state.auth.role);
    const semester = useSelector((state) => state.schedule.scheduleSemester);
    const group = useSelector((state) => state.schedule.scheduleGroup);
    const teacher = useSelector((state) => state.schedule.scheduleTeacher);
    const department = useSelector((state) => state.schedule.scheduleDepartment);

    const isManager = userRole === userRoles.MANAGER;
    const { data: defaultSemester = {} } = useDefaultSemester();

    // Groups belong to a semester, so the group filter has no options until one is loaded. A
    // manager picks the semester and reloads them; everyone else only ever sees the default one.
    useEffect(() => {
        if (defaultSemester?.id) {
            dispatch(getAllPublicGroupsStart(defaultSemester.id));
        }
    }, [defaultSemester?.id, dispatch]);

    const {
        control,
        handleSubmit,
        setValue,
        reset,
        formState: { isDirty, isSubmitting },
    } = useForm({
        defaultValues: { semester: null, group: null, teacher: null, department: null },
    });

    useEffect(() => {
        reset({ semester, group, teacher, department });
    }, [semester, group, teacher, department, reset]);

    return (
        <FormWrapper
            onSubmit={handleSubmit(onSubmit)}
            isDirty={isDirty}
            isSubmitting={isSubmitting}
            submitLabel={t('preview')}
            submitClassName="schedule-form_submit"
            showReset={false}
            noCard
            formClassName={`schedule-form ${!isManager ? 'no-semester' : ''}`}
        >
            {isManager && <SemestersList control={control} setValue={setValue} />}
            <GroupsList control={control} setValue={setValue} />
            <TeachersList control={control} setValue={setValue} />
            <DepartmentsList control={control} setValue={setValue} />
        </FormWrapper>
    );
};

export default SchedulePageForm;
